import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import React from "react";

import { METRIC_LIMIT_MAPPINGS } from "config/copies/detectorMetrics";
import { AnswerType, useTopLevelStats } from "hooks/DetectorDetail/useTopLevelStats";

interface StatsSelectorsProps {
  period: ReturnType<typeof useTopLevelStats>["period"];
  handleActivityPeriodChange: ReturnType<typeof useTopLevelStats>["handleActivityPeriodChange"];
  answerType: ReturnType<typeof useTopLevelStats>["answerType"];
  handleAnswerTypeChange: ReturnType<typeof useTopLevelStats>["handleAnswerTypeChange"];
}

export function StatsSelectors(props: StatsSelectorsProps) {
  const { period, handleActivityPeriodChange, answerType, handleAnswerTypeChange } = props;

  return (
    <div className="flex flex-row gap-2">
      <FormControl className="w-1/2">
        <Select
          label=""
          id="period-select"
          value={period.ui}
          onChange={handleActivityPeriodChange}
          sx={{ padding: 0 }}
          className="normal-case mt-auto"
          classes={{ select: "text-base" }}
        >
          {METRIC_LIMIT_MAPPINGS.map((limitMapping) => (
            <MenuItem
              key={limitMapping.ui}
              value={limitMapping.ui}
              classes={{
                root: "text-base",
                selected: "text-base",
              }}
            >
              {limitMapping.ui}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl className="w-1/2">
        <InputLabel className="ml-2 text-black flex items-center">Answer Type</InputLabel>
        <Select
          classes={{ select: "text-base" }}
          onChange={handleAnswerTypeChange}
          value={answerType}
          label="Answer Type"
        >
          <MenuItem value={AnswerType.FIRST_ANSWER}>First answer</MenuItem>
          <MenuItem value={AnswerType.BEST_ANSWER}>Best answer</MenuItem>
        </Select>
      </FormControl>
    </div>
  );
}
